var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockifyLogoWithName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 634.60876,
    height: 127.99999,
    viewBox: "0 0 167.9069 33.866664",
    id: "svg1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title3"
  }, "Stockify Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title3"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(199.68346,-86.351715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(1.1132622,0,0,1.1132622,1.9523488e-6,1.7972386e-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11",
    transform: "scale(0.89826077)",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f00a0",
      fillOpacity: 1,
      strokeWidth: 1.68537,
      strokeDasharray: "none"
    },
    d: "M 9.6884753,3.1029181e-7 H 43.598131 c 4.844235,0 4.844235,9.69672508970819 0,9.69672508970819 H 14.53271 c -4.8442347,0 -4.8442347,0 -4.8442347,4.8483466 v 29.090143 c 0,4.848363 -9.688475383789587,4.848363 -9.688475383789587,0 V 9.6967254 C -8.3789587e-8,4.8483628 4.8442455,3.1029181e-7 9.6884753,3.1029181e-7 Z",
    id: "path14-2-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path14-2-3",
    id: "use14-3-8",
    transform: "matrix(0,1.0008509,-0.99914984,0,135.46667,3.1029181e-7)",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path14-2-3",
    id: "use14-5-2-7",
    transform: "rotate(180,67.733332,67.733335)",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path14-2-3",
    id: "use14-1-2-4",
    transform: "matrix(0,-1.0008509,0.99914984,0,1.8437044e-5,135.46665)",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(2.0856941)",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 39.154862,67.131306 C 35.626825,65.813792 31.702121,63.107253 29.946664,61.458729 27.659259,59.346564 25.903814,56.77075 24.680315,53.731298 23.669603,51.207 23.084448,48.425131 22.924862,45.33416 v 0 c 0,-0.669716 -0.05317,-1.339425 -0.05317,-2.00914 v 0 0 c 0,-3.915229 0.638352,-7.418333 1.861848,-10.457785 1.223496,-3.039465 2.984402,-5.611316 5.271806,-7.723479 2.287405,-2.112175 5.000378,-3.709171 8.138909,-4.791011 3.13853,-1.081839 6.702628,-1.719822 10.585902,-1.719822 l 49.954037,-1e-6 -16.916979,16.917103 H 50.326029 c -2.500188,0 -4.574812,0.77275 -6.17068,2.31823 -1.595869,1.545489 -2.393797,3.606136 -2.393797,6.181949 0,2.575805 0.797928,4.533429 2.393797,6.078908 2.102647,2.111662 3.023806,2.314278 5.855091,2.314278 L 66.85636,69.289194 H 49.627767 c -4.177321,-0.200969 -6.94485,-0.840388 -10.472875,-2.157888 z",
    id: "path2-6-6",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1,
      strokeWidth: 0.52349
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 82.359336,54.601249 c 3.528037,1.317514 7.452741,4.024053 9.208198,5.672577 2.287405,2.112165 4.04285,4.687979 5.266349,7.727431 1.010712,2.524298 1.595867,5.306167 1.755453,8.397138 v 0 c 0,0.669716 0.05317,1.339425 0.05317,2.00914 v 0 0 c 0,3.915229 -0.638352,7.418333 -1.861848,10.457785 -1.223496,3.039465 -2.984402,5.611316 -5.271806,7.723479 -2.287405,2.112175 -5.000378,3.709151 -8.138909,4.790991 -3.13853,1.08185 -6.702628,1.71984 -10.585902,1.71984 H 22.830004 l 16.916979,-16.9171 h 31.441186 c 2.500188,0 4.574812,-0.77275 6.17068,-2.31823 1.595869,-1.545489 2.393797,-3.606136 2.393797,-6.181949 0,-2.575805 -0.797928,-4.533429 -2.393797,-6.078908 -2.102647,-2.111662 -3.499136,-2.314278 -6.330421,-2.314278 L 54.182508,52.443361 h 17.703923 c 4.177321,0.200969 6.94485,0.840388 10.472875,2.157888 z",
    id: "path1",
    style: {
      fill: "#5f00a0",
      fillOpacity: 1,
      strokeWidth: 0.52349
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g49"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#g12",
    id: "use13",
    transform: "matrix(0.25000005,0,0,0.25000005,-199.68345,86.351716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fontWeight: 600,
      fontSize: "24.6066px",
      lineHeight: 0,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat Semi-Bold'",
      textAlign: "center",
      letterSpacing: "1.32292px",
      textAnchor: "middle",
      fill: "#1a1a1a",
      strokeWidth: 6.91003
    },
    d: "m -146.49327,111.05664 q -2.01774,0 -3.86324,-0.56595 -1.84549,-0.59056 -2.92818,-1.501 l 1.10729,-2.48527 q 1.03348,0.81202 2.55909,1.35337 1.52561,0.54134 3.12504,0.54134 1.35336,0 2.18999,-0.29528 0.83662,-0.29528 1.23033,-0.78741 0.3937,-0.51674 0.3937,-1.15651 0,-0.78741 -0.56595,-1.25494 -0.56595,-0.49213 -1.4764,-0.7628 -0.88583,-0.29528 -1.99313,-0.54135 -1.08269,-0.24606 -2.18999,-0.56595 -1.08269,-0.34449 -1.99313,-0.86123 -0.88584,-0.54134 -1.45179,-1.42718 -0.56595,-0.88584 -0.56595,-2.263809 0,-1.402576 0.73819,-2.559086 0.76281,-1.181117 2.28842,-1.870102 1.55021,-0.713591 3.91245,-0.713591 1.55021,0 3.07582,0.393705 1.52561,0.393706 2.65751,1.131904 l -1.00887,2.485266 q -1.15651,-0.688984 -2.38684,-1.00887 -1.23033,-0.344493 -2.36223,-0.344493 -1.32876,0 -2.16538,0.319886 -0.81202,0.319886 -1.20572,0.836624 -0.3691,0.516739 -0.3691,1.181117 0,0.787411 0.54134,1.279543 0.56595,0.467526 1.45179,0.738196 0.91045,0.27068 2.01774,0.54135 1.1073,0.24606 2.18999,0.56595 1.1073,0.31989 1.99314,0.83662 0.91044,0.51674 1.45178,1.40258 0.56596,0.88584 0.56596,2.2392 0,1.37797 -0.76281,2.55909 -0.7382,1.15651 -2.28841,1.8701 -1.55022,0.68898 -3.91245,0.68898 z m 16.11147,-0.0738 q -2.16538,0 -3.34649,-1.10729 -1.18112,-1.13191 -1.18112,-3.32189 V 94.767074 h 3.07583 v 11.712746 q 0,0.93505 0.46752,1.45179 0.49213,0.51673 1.35336,0.51673 1.03348,0 1.72247,-0.54134 l 0.86123,2.18999 q -0.54135,0.44291 -1.32876,0.66437 -0.78741,0.22146 -1.62404,0.22146 z m -6.69299,-10.85151 v -2.460657 h 8.75995 v 2.460657 z m 18.97542,10.85151 q -2.01774,0 -3.59256,-0.86123 -1.57482,-0.88583 -2.48527,-2.41144 -0.91044,-1.52561 -0.91044,-3.46953 0,-1.96853 0.91044,-3.46954 0.91045,-1.525605 2.48527,-2.386836 1.57482,-0.861231 3.59256,-0.861231 2.04235,0 3.61718,0.861231 1.59942,0.861231 2.48526,2.362236 0.91045,1.501 0.91045,3.49414 0,1.94392 -0.91045,3.46953 -0.88584,1.52561 -2.48526,2.41144 -1.57483,0.86123 -3.61718,0.86123 z m 0,-2.6329 q 1.13191,0 2.01775,-0.49213 0.88583,-0.49214 1.37797,-1.42719 0.51673,-0.93505 0.51673,-2.18998 0,-1.27955 -0.51673,-2.18999 -0.49214,-0.93505 -1.37797,-1.42718 -0.88584,-0.49214 -1.99314,-0.49214 -1.1319,0 -2.01774,0.49214 -0.86123,0.49213 -1.37797,1.42718 -0.51674,0.91044 -0.51674,2.18999 0,1.25493 0.51674,2.18998 0.51674,0.93505 1.37797,1.42719 0.88584,0.49213 1.99313,0.49213 z m 17.31722,2.6329 q -2.06695,0 -3.69099,-0.86123 -1.59943,-0.88583 -2.50987,-2.41144 -0.91045,-1.52561 -0.91045,-3.46953 0,-1.96853 0.91045,-3.46954 0.91044,-1.525605 2.50987,-2.386836 1.62404,-0.861231 3.69099,-0.861231 1.919316,0 3.371105,0.787412 1.476396,0.762804 2.239201,2.263805 l -2.362234,1.37797 q -0.590558,-0.93505 -1.451789,-1.37797 -0.836624,-0.44292 -1.820893,-0.44292 -1.1319,0 -2.04234,0.49214 -0.91045,0.49213 -1.42719,1.42718 -0.51673,0.91044 -0.51673,2.18999 0,1.27954 0.51673,2.21459 0.51674,0.91044 1.42719,1.40258 0.91044,0.49213 2.04234,0.49213 0.984269,0 1.820893,-0.44292 0.861231,-0.44292 1.451789,-1.37797 l 2.362234,1.37797 q -0.762805,1.47639 -2.239201,2.28841 -1.451789,0.78741 -3.371105,0.78741 z m 11.972137,-3.10043 0.07382,-3.86323 6.865242,-6.348507 h 3.69099 l -5.831764,5.856367 -1.624036,1.35337 z m -2.509874,2.92819 v -18.2581 h 3.075825 v 18.2581 z m 9.91646,0 -4.798287,-5.93019 1.943922,-2.46066 6.594568,8.39085 z m 7.031653,0 V 97.670653 h 3.075825 v 13.139927 z m 1.550216,-15.305308 q -0.861231,0 -1.427183,-0.541345 -0.541345,-0.541345 -0.541345,-1.30415 0,-0.787411 0.541345,-1.304149 0.565952,-0.541346 1.427183,-0.541346 0.861231,0 1.402576,0.516739 0.565952,0.492132 0.565952,1.254937 0,0.812017 -0.541346,1.377969 -0.541345,0.541345 -1.427182,0.541345 z m 7.302308,15.305308 V 96.932455 q 0,-2.066954 1.205723,-3.297284 1.23033,-1.254937 3.494137,-1.254937 0.812018,0 1.52561,0.172246 0.738198,0.172247 1.23033,0.541346 l -0.836625,2.31302 q -0.344492,-0.270673 -0.787411,-0.393706 -0.442919,-0.147639 -0.910444,-0.147639 -0.959658,0 -1.45179,0.541345 -0.492132,0.516739 -0.492132,1.574822 v 1.476396 l 0.09843,1.37797 v 10.974546 z m -2.165381,-10.58084 v -2.460661 h 8.75995 v 2.460661 z m 13.232499,15.52676 q -0.959657,0 -1.919314,-0.31988 -0.959658,-0.31989 -1.599429,-0.88584 l 1.23033,-2.26381 q 0.467525,0.41832 1.058083,0.66438 0.590559,0.24607 1.205724,0.24607 0.836624,0 1.353363,-0.41831 0.516738,-0.41832 0.959657,-1.40258 l 0.762805,-1.72246 0.246066,-0.3691 4.970533,-11.614317 h 2.952792 l -6.15165,14.198007 q -0.615165,1.4764 -1.37797,2.33763 -0.738198,0.86123 -1.673248,1.20572 -0.910445,0.34449 -2.017742,0.34449 z m 2.706726,-4.4784 -5.93019,-13.607447 h 3.198858 l 4.822893,11.343647 z",
    id: "text1",
    "aria-label": "Stockify"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      strokeWidth: 1.23143
    },
    id: "rect1",
    width: 11.720965,
    height: 32.596657,
    x: -165.81429,
    y: 86.359993
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1.23143
    },
    id: "rect1-3",
    width: 11.720965,
    height: 32.596657,
    x: -43.497501,
    y: 86.359993
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockifyLogoWithName);
export default __webpack_public_path__ + "static/media/stockify_logo_with_name.dd7f197bd194eef5f1efeb4f9ae0fac6.svg";
export { ForwardRef as ReactComponent };